module.exports = __webpack_public_path__ + "img/壹胜百.c34d3596.jpg";